export enum CorporateActionType {
    ACQUIS = 'Acquisition',
    BANCR = 'Bankruptcy Filing',
    CHG_DOM = 'Domicile Change',
    CHG_ID = 'ID Change',
    CHG_LIST = 'Listing Change',
    CHG_NAME = 'Name Change',
    CHG_RLOT = 'RLOT Change',
    CHG_TKR = 'Ticker Change',
    CRNCY_QT_CHNG = 'Currency Quotation Change',
    DELIST = 'Delisting',
    DIVEST = 'Divestiture',
    DVD_CASH = 'Cash Dividend',
    DVD_STOCK = 'Stock Dividend',
    EQY_OFFER = 'Equity Offering',
    LIST = 'New Listing',
    PARTIAL_PAY = 'Partial Pay',
    RECLASS = 'Reclassification',
    RIGHTS_OFFER = 'Rights Offering',
    SH_HOLDER_MEET = 'Shareholder Meeting',
    SPIN = 'Spin Off',
    STOCK_BUY = 'Stock Buyback',
    STOCK_SPLT = 'Stock Split',
    EARN_RLS = 'Earnings Release',
}

// We receive this value eg "DIVEST" in the API...
export type CorporateActionTypeValue = keyof typeof CorporateActionType;
